import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Input } from "../../../components/core/Input";
import LavorisService from "../../../services/LavorisService";
import { DATAJSON } from "./json/detailsBranchFORM";
import StyledWrapper from "./style";
import { CircularProgress } from "@mui/material";
type TProps = {
  companyId: any;
  onClose: Function;
};

export default function DetalleSucursal({ companyId }: TProps) {
  //useState
  const [isReady, setIsReady] = useState(false);
  const LavorisInstance = LavorisService.getInstance();


  const {
    register,
    reset,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const getCompanyProfile = async () => {
    try {
      if (companyId) {
        const companyProfile: any =
          await LavorisInstance.CompanyServices.getCompanyProfile(companyId);
        if (companyProfile) {
          reset({
            branchOfficeName: companyProfile.branchOfficeName,
            fantasyName: companyProfile.fantasyName,
            socialReason: companyProfile.socialReason,
            managerId: companyProfile.managerId,
            heading: companyProfile.heading,
            cuit: companyProfile.cuit,
            ivaCondition: companyProfile.ivaCondition,
            email: companyProfile.email,
            ART: companyProfile.ART, //Barrio
            location: companyProfile.location,
            residence: companyProfile.residence, //Nombre y altura de la calle
            province: companyProfile.province,
            postalCode: companyProfile.postalCode,
            phoneNumber: companyProfile.phoneNumber,
            comments: companyProfile.comments,
          })
          setIsReady(true);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  // useEffects
  useEffect(() => {
    if (!companyId) return;
    const getData = async () => {
      await getCompanyProfile();
    };
    getData();
  }, [companyId]);

  if (!isReady) return <div className="flex align-middle justify-center my-5"><CircularProgress color="error" size={15} /></div>;
  return (
    <div className="w-full h-full">
      <form>
        <StyledWrapper.FormContainer>
          {DATAJSON.map((obj: any, index: number) => (
            <>
              {obj.type === "text" ? (
                <Input
                  key={index}
                  type="text"
                  label={obj.label || ""}
                  fieldName={obj.fieldName}
                  register={register}
                  required={obj.required ? true : false}
                  error={errors?.[obj.fieldName]}
                  readOnly={obj.readOnly}
                />
              ) : null}
              {obj.type === "tittle" ? (
                <StyledWrapper.Tittle>{obj.label}</StyledWrapper.Tittle>
              ) : null}
              {obj.type === "subtittle" ? (
                <StyledWrapper.SubTittle>{obj.label}</StyledWrapper.SubTittle>
              ) : null}
              {obj.type === "normalText" ? (
                <p key={index}>{obj.label}</p>
              ) : null}
            </>
          ))}
        </StyledWrapper.FormContainer>
      </form>
    </div>
  );
}
